import React from 'react'

import Button from '@/components/button/button'

import bars from './bars.svg'
import * as style from './hero.module.scss'

interface ReportHeroProps {
  text: string
  subtitle: string
  title: string
  cta: Queries.DatoCmsCta | null
}

const ReportHero: React.FC<ReportHeroProps> = ({ subtitle, title, cta }) => {
  return (
    <section className={`${style.section} bg-base-000`}>
      <div className="container">
        <div className="row justify-content-center align-items-end">
          <div className="col-12 col-md-8 col-lg-7 col-xxl-6">
            <h1
              className={`${style.title} h400 text-uppercase text-center text-base-1000`}
            >
              {title}
            </h1>
          </div>
          <div
            className={`${style.scrolling} d-flex flex-column align-items-center`}
          >
            <h2
              className={`${style.subtitle} text-base-1000 h400 text-uppercase`}
            >
              {subtitle}
            </h2>
            <Button
              className={style.button}
              title="Download"
              color="custom"
              to={cta?.link ?? ''}
              icon="download"
            />
            {/*
              <p className={`text-base-1000 b100 text-uppercase`}>{text}</p>
            */}
          </div>
        </div>
      </div>
      <img
        src={bars}
        alt="bars"
        className={`${style.bars} ${style.barLeft}`}
        loading="lazy"
      />
      <img
        src={bars}
        alt="bars"
        loading="lazy"
        className={`${style.bars} ${style.barRight}`}
      />
    </section>
  )
}

export default ReportHero
